import fetch from '../utils/Api';
import { isFile, blobToFile } from '../utils';
import axios from 'axios';
import AWS from 'aws-sdk';
import mime from 'mime-types';
import uuidv4 from 'uuid/v4';

import {
  PHONE_REGISTRATION,
  PHONE_HAS_REGISTRATION,
  ONE_TIME_PASSWORD,
  BECOME_SELLER,
  AUTH_TOKEN_KEY,
  MAKE_SALE_REQUEST,
  CLEAR_SELL_REQUEST,
  SELLER_UPLOAD_PHOTO,
  SAVING_SELLER_IMAGE,
  API_BASE_URL,
  SUSPEND_SELL_REQUEST,
  RESET_TOKEN_TOBE_SELLER,
  FETCH_PRICE_COMPETITOR,
  GET_TRANSACTION_TIMELINE,
  SENT_SMS,
  SENT_CALL,
} from '../constants';

import slugify from '../utils/slugify';

export const doHasPhoneRegis = () => ({
  type: PHONE_HAS_REGISTRATION,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .get('/users/sms')
    .then((response) => response.data),
});

export const doSubmitPhone = (payload) => {
  const formData = new FormData();
  formData.append("full_name", payload.full_name);
  formData.append("id_card", payload.id_card);
  formData.append("mobile_number", payload.mobile_number);
  formData.append("type", payload.type);
  formData.append("address", payload.address);
  if (!isFile(payload.seller_verification_image)) {
    formData.append(`seller_verification_image[0]`, blobToFile(payload.seller_verification_image));
  }
  else {
    formData.append(`seller_verification_image[0]`, payload.seller_verification_image);
  }

  return {
    type: PHONE_REGISTRATION,
    payload: fetch({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
      'Content-Type': 'multipart/form-data',
    })
      .post('/users/sms/registrations', formData)
      .then((response) => response.data)
      .catch((err) => { throw err.response.data.error }),
  };
};

export const doSentSMS = (payload) => ({
  type: SENT_SMS,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .post('/users/sms', payload)
    .then((res) => res.data),
});

export const doSentCitCall = (payload) => ({
  type: SENT_CALL,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .post('/users/citcall', payload)
    .then((res) => res.data),
});

export const checkOtpCode = (payload) => ({
  type: 'CHECK_OTP_CODE',
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .post('/users/otp/verifications', payload)
    .then((response) => response.data),
});

export const doSeller = (payload) => ({
  type: BECOME_SELLER,
});

export const doSellerToken = (payload) => ({
  type: RESET_TOKEN_TOBE_SELLER,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .get('/auth/token/generate')
    .then((response) => response.data),
});

export const doVerifyOtp = (payload) => ({
  type: ONE_TIME_PASSWORD,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .post('/users/sms/verifications', payload)
    .then((response) => response.data),
});

export const makeSellRequest = (dataSelling) => ({
  type: MAKE_SALE_REQUEST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .post('/users/sells', dataSelling)
    .then((res) => res.data),
});

export const makeSellRequestHandbag = (dataSelling) => ({
  type: MAKE_SALE_REQUEST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .post('/users/sells/handbags', dataSelling)
    .then((res) => res.data),
});

// SELLER UPLOAD S3
export const uploadProducts = (files, id_user, stepUpload) => (dispatch) => {
  // let imageSucces = [];
  // const RootFolder = 'seller-upload-products';
  // const BucketName = document.location.hostname.indexOf("www.kickavenue.com") !== -1 ? BUCKET_NAME_USER : BUCKET_NAME_DEV;
  // const resourcesURL = document.location.hostname.indexOf("www.kickavenue.com") !== -1 ? RESOURCE_URL_USER : RESOURCE_URL_DEV;
  // // console.log('ACTIONS VARIABLE ', files);
  // const uuid=uuidv4();
  // const filename=`${slugify((files.name.substr(0, files.name.lastIndexOf('.'))||files.name))}-${uuid.substr(0,uuid.indexOf('-'))}`;
  // const key = `${RootFolder}/${id_user}/${filename}.${mime.extension(files.type)}`;
  // // console.log('BucketName NYA ', BucketName);
  // // console.log('resourcesURL NYA ', resourcesURL);
  // s3().putObject({
  //     Bucket: BucketName,
  //     Key: key,
  //     Body: files,
  //     ContentType: mime.lookup(files.name),
  //     ACL: 'public-read',
  //   }, (err) => {
  //     if(err === null) {
  //       let countUpload = imageSucces.length === files.length ? false : true;
  //       const result = {
  //         identifier: uuid,
  //         prefix:resourcesURL,
  //         folder: RootFolder,
  //         url:`${resourcesURL}${key}`,
  //         stepUpload
  //       }
  //       // imageSucces.push(result);
  //       dispatch({
  //         type: SELLER_UPLOAD_PHOTO,
  //         payload: result,
  //         isProgress: countUpload
  //       })
  //       // if (imageSucces.length === files.length) {
  //       //   dispatch(saveImageUrl(imageSucces))
  //       // }
  //     } else {
  //       console.log('EROR ', err);
  //       // dispatch({type: SELLER_UPLOAD_PHOTO, payload: err})
  //     }
  //   })
};
// --

// export const uploadProducts = (files, id_user) => dispatch => {
//   let imageSucces = [];
//   for (let i = 0; i < files.length; i++) {
//     const uuid=uuidv4();
//     const filename=`${slugify((files[i].name.substr(0, files[i].name.lastIndexOf('.'))||files[i].name))}-${uuid.substr(0,uuid.indexOf('-'))}`;
//     const key = `user-sells/${id_user}/${filename}.${mime.extension(files[i].type)}`;

//     s3().putObject({
//       Bucket: BUCKET_NAME_DEV,
//       Key: key,
//       Body: files[i],
//       ContentType: mime.lookup(files[i].name),
//       ACL: 'public-read',
//     }, (err) => {
//       if(err === null) {
//         let countUpload = imageSucces.length === files.length ? false : true;
//         const result = {
//           identifier: uuid,
//           prefix:RESOURCE_URL_DEV,
//           folder:'user-sells',
//           url:`${RESOURCE_URL_DEV}${key}`
//         }
//         imageSucces.push(result);
//         dispatch({
//           type: SELLER_UPLOAD_PHOTO,
//           payload: result,
//           isProgress: countUpload
//         })
//         // if (imageSucces.length === files.length) {
//         //   dispatch(saveImageUrl(imageSucces))
//         // }
//       } else {
//         dispatch({type: SELLER_UPLOAD_PHOTO, payload: err})
//       }
//     })
//   }
// }

// export const saveImageUrlSuccess = (images) => ({
//   type: SAVING_SELLER_IMAGE,
//   payload: images,
// })
// export const saveImageUrl = (saveImages) => {
//   const instance = axios.create({
//     baseURL: API_BASE_URL,
//     headers: {
//       'Authorization': 'Bearer ' +localStorage.getItem(AUTH_TOKEN_KEY)
//     }
//   })
//   return dispatch => (
//     instance.post('users/sells/images', saveImages)
//       .then(res => {
//         dispatch(saveImageUrlSuccess(res.data))
//       })
//       .catch(err => {
//         dispatch(saveImageUrlSuccess(err))
//       })
//   )
// }

export const saveImageUrl = ({ id, compressedImages, category }) => {
  let formData = new FormData();
  formData.append('id', id);
  formData.append('category', category);

  if (!isFile(compressedImages)) {
    formData.append(`user_sell_images[0]`, blobToFile(compressedImages));
  } else formData.append(`user_sell_images[0]`, compressedImages);

  return {
    type: SAVING_SELLER_IMAGE,
    payload: fetch({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
      'Content-Type': 'multipart/form-data',
    })
      .post('v2/users/sells/images', formData)
      .then((response) => {
        return response.data;
      })
      .catch((err) => err),
  };
};

export const handleSuspended = (sellId, statusSell) => ({
  type: SUSPEND_SELL_REQUEST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .put(`users/sells/${sellId}`, statusSell)
    .then((response) => response.data),
});

export const getPriceCompetitor = (params) => ({
  type: FETCH_PRICE_COMPETITOR,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .post('products/prices', params)
    .then((res) => res.data),
});

export const getTransactionTimeline = (params) => ({
  type: GET_TRANSACTION_TIMELINE,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .get(`/settings`, params)
    .then((response) => response.data),
});

export const setSelectedUserSell = (payload) => ({
  type: "SET_SELECTED_USER_SELL",
  payload
});
